import Helper from "../../Helper";
import { Gate } from "../../models/Gate";
import { MapObject } from "../../models/MapObject";
import { plotFetch } from "../Helper/ApiRequest";

export function getProjectGates(team_subdomain: string, project_token: string, timezone: string): Promise<Gate[]> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/gates`;

    return plotFetch(url, { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response.map((gate: any) => Gate.fromApiObject(gate, timezone));
        })
        .catch((_) => {
            return [];
        });
}

export function getProjectGate(
    team_subdomain: string,
    project_token: string,
    gate_id: number,
    timezone: string
): Promise<Gate | null> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/gates/${gate_id}`;

    return plotFetch(url, { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .then((response) => {
            if (response) {
                return Gate.fromApiObject(response, timezone);
            }

            return null;
        })
        .catch((_) => {
            return null;
        });
}

export function getGateAttachments(team_subdomain: string, project_token: string, gate_id: number): Promise<any[]> {
    const url = `${Helper.baseUrlAltSubdomain(team_subdomain || "projects")}/projects/${project_token}/gates/${gate_id}/gates_attachments`;

    return plotFetch(url, { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .catch((_) => {
            return [];
        });
}

export function createGate(
    team_subdomain: string,
    project_token: string,
    gate: Gate,
    map_object: MapObject,
    timezone: string
): Promise<Gate | null> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/gates`;

    return plotFetch(
        url,
        {
            method: "POST",
            body: JSON.stringify({
                gate: gate.toApiObject(),
                map_object: map_object.toApiObject(),
            }),
        },
        true
    )
        .then(async (data) => {
            const jsonData = await data.json();
            if (!data.ok) {
                const errorMessage = jsonData.error || data.statusText;
                throw new Error(errorMessage);
            }
            return jsonData;
        })
        .then((data) => {
            return Gate.fromApiObject(data, timezone);
        })
        .catch(() => {
            return null;
        });
}

export function deleteGate(team_subdomain: string, project_token: string, gate: Gate): Promise<boolean> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/gates/${gate.id}`;

    return plotFetch(url, { method: "DELETE" }, true)
        .then((response) => {
            if (response.ok) {
                return true;
            }
            throw new Error("Network error.");
        })
        .catch(() => {
            return false;
        });
}

export function updateGate(
    team_subdomain: string,
    projectToken: string,
    gate: Gate,
    timezone: string
): Promise<Gate | null> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${projectToken}/gates/${gate.id}`;

    return plotFetch(url, {
        method: "PUT",
        body: JSON.stringify({ gate: gate.toApiObject() }),
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .then((response) => {
            if (response) {
                return Gate.fromApiObject(response, timezone);
            }

            return null;
        })
        .catch((_) => {
            return null;
        });
}

// Sends only banned_vehicles, so saving the vehicle switches doesn't also save other unsaved edits to the location.
export function updateGateBannedVehicles(
    team_subdomain: string,
    projectToken: string,
    id: number,
    bannedVehicles: string[]
): Promise<boolean> {
    return plotFetch(
        `${Helper.baseUrlAltSubdomain(team_subdomain || "projects")}/projects/${projectToken}/gates/${id}`,
        {
            method: "PUT",
            body: JSON.stringify({ gate: { banned_vehicles: bannedVehicles } }),
        }
    )
        .then((response) => response.ok)
        .catch(() => false);
}
